module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921065649_T.4bd07bbe.jpg";